import React, { Component } from 'react';
import {
  connect
} from 'react-redux';
import { setAuthToken } from "../../utils/helper";
import Cookies from 'js-cookie';
import { logoutUser } from "../../actions/AuthActions";

// import { useHistory } from "react-router-dom";

import { configureStore } from './../../store';

const store = configureStore();

class Logout extends Component {

  constructor(props) {
    super(props);
    store.dispatch(logoutUser());
    // localStorage.removeItem("jwtToken");
    // Cookies.remove('token');
    // setAuthToken(false);
    if (typeof window !== "undefined") {
      window.location = '/';
    }

  }

  render() {
    return false
  }
}
export default Logout;



// WEBPACK FOOTER //
// ./client/src/views/Logout/index.js